import Box from "@mui/material/Box"
import Typography from '@mui/material/Typography'
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const SearchResultComponent = (props) => {
    const [t] = useTranslation("common");
    const maintheme = useSelector((state) => state.themeData.maintheme);

    return (
        <Box
            sx={{
                display: 'flex',
                backgroundColor: maintheme?.gray,
                padding: '10px',
                borderRadius: '10px',
                marginLeft: '10px',
                marginRight: '10px',
                gap: '15px',
                minWidth: 'fit-content'
            }}
        >
            <Typography sx={{
                fontFamily: 'Cairo',
            }}>{t('GLOBAL.SEARCH_RESULT_OF_SEARCH')}  {props?.resultLength}
            </Typography>
            {props?.totalWeight !== undefined && props?.totalWeight !== null ? (
                <Typography sx={{
                    fontFamily: 'Cairo',
                    backgroundColor: maintheme?.primary + '22',
                    padding: '0 8px',
                    borderRadius: '5px',
                }}>الوزن الكلي: {props?.totalWeight?.toFixed(2)} طن
                </Typography>
            ) : null}
        </Box>
    );
};

export default SearchResultComponent;
